export default __webpack_public_path__ + "static/media/logo_256.4239e45f.webp";